
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freelancer",
      function () {
        return require("private-next-pages/freelancer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freelancer"])
      });
    }
  